<!--
   Created by qing on 2020/12/29
   Des:
-->
<template>
	<ConfigContainer
		:isPhone="isPhone"
		:value="current"
		:type="type"
	>
		<div class="todo-config-container">
			<div class="phone-wide-todo-config-wrapper">
				<el-row
					type="flex"
					justify="space-around"
					style="width: 100%;"
				>
					<el-col :span="5">
						<div
							class="item"
							@click="onClickItem('4')"
						>
							<i class="iconfont icon-todo-forms"></i>
							<div class="text">
								我的待办
							</div>
							<div
								class="badge"
								v-if="current.todoBadge"
							>
								{{current.todoBadge}}
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div
							class="item"
							@click="onClickItem('5')"
						>
							<i class="iconfont icon-cc-me"></i>
							<div class="text">
								我发起的
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div
							class="item"
							@click="onClickItem('6')"
						>
							<svg
								t="1656316715085"
								class="icon-cc"
								viewBox="0 0 1024 1024"
								version="1.1"
								xmlns="http://www.w3.org/2000/svg"
								p-id="4581"
								width="21"
								height="21"
							>
								<path
									d="M860.5 235.092c44.459 0 80.5 36.041 80.5 80.5V853.5c0 44.459-36.041 80.5-80.5 80.5H320.163c-44.459 0-80.5-36.041-80.5-80.5V751.226h464.473c44.015 0 79.779-35.324 80.49-79.168l0.01-1.332V235.091H860.5zM655.848 96c44.459 0 80.5 36.041 80.5 80.5v450.545c0 44.459-36.041 80.5-80.5 80.5H161.5c-44.459 0-80.5-36.041-80.5-80.5V415.993h389.06l-111.273 111.84-0.545 0.562c-11.094 11.739-10.863 30.248 0.656 41.705 11.704 11.64 30.631 11.591 42.275-0.11l160.962-161.777 0.55-0.566c10.977-11.62 10.877-29.901-0.362-41.4L401.36 201.558l-0.555-0.554c-11.583-11.256-30.097-11.287-41.717 0.066l-0.554 0.555c-11.258 11.58-11.29 30.092 0.066 41.71l110.327 112.882L81 356.217V176.5c0-44.459 36.041-80.5 80.5-80.5h494.348z"
									fill="#4260FA"
									p-id="4582"
								></path>
							</svg>
							<div class="text">
								抄送我的
							</div>
							<div
								class="badge"
								v-if="current.ccBadge"
							>
								{{current.ccBadge}}
							</div>
						</div>
					</el-col>
					<el-col :span="5">
						<div
							class="item"
							@click="onClickItem('2')"
						>
							<i class="iconfont icon-handle-form"></i>
							<div class="text">
								即将超时
							</div>
							<div
								class="badge"
								v-if="current.timeoutBadge"
							>
								{{current.timeoutBadge}}
							</div>
						</div>
					</el-col>
				</el-row>
			</div>

		</div>
	</ConfigContainer>

</template>

<script>
	import ConfigContainer from './common/ConfigContainer'
	import TodoConfig from "../instances/TodoConfig";
	import {
		TODO_SHOW_TYPE__WIDE
	} from "../type";
	import {
		MESSAGE_REFRESH_TYPE_REMIND,
		MESSAGE_REFRESH_TYPE_TODO
	} from "../../RyForm/types";

	export default {
		props: {
			value: Object,
			type: Number,
			isPhone: {
				type: Boolean,
				default: false
			}
		},
		components: {
			ConfigContainer
		},
		data() {
			return {
				TODO_SHOW_TYPE__WIDE,
				current: this.value,
			}
		},
		created() {
			document.addEventListener('NEW_MESSAGE', this.receiveNewMessage)
		},
		destroyed() {
			document.removeEventListener('NEW_MESSAGE', this.receiveNewMessage)
		},
		methods: {
			receiveNewMessage(e) {
				console.log('NEW_MESSAGE--', e)
				if (e.detail && e.detail.content) {
					if (e.detail.content.refreshType === MESSAGE_REFRESH_TYPE_TODO ||
						e.detail.content.refreshType === MESSAGE_REFRESH_TYPE_REMIND) {
						this.current.getValue()
					}
				}
			},

			onClickItem(type) {
				sessionStorage.setItem('tabActive', type)
				this.$router.push({
					name: 'flowListTodo'
				})
			}
		}
	}
</script>

<style lang="less">
	.todo-config-container {
		width: 100%;
		height: 100%;

		.phone-wide-todo-config-wrapper {
			display: flex;
			height: 100%;

			.el-row {
				width: 100%;

				.el-col {
					height: 100%;
				}
			}

			.item {
				position: relative;
				cursor: pointer;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				width: 100%;
				height: 100%;
				max-width: 180px;
				border-radius: 12px;
				background: #fff;

				.badge {
					position: absolute;
					top: 20px;
					right: 5px;
					width: 26px;
					height: 20px;
					background: #4260FA;
					color: #fff;
					font-size: 12px;
					border-radius: 72px;
					line-height: 20px;
					text-align: center;
				}

				i,.icon-cc {
					font-size: 20px;
					margin-bottom: 10px;
				}

				.text {
					font-size: 13px;
					line-height: 22px;
					height: 22px;
				}

				.icon-todo-forms {
					color: #4260FA;
				}

				.icon-apply-form {
					color: #4260FA;
					font-size: 18px;
					margin-bottom: 12px;
				}

				.icon-handle-form {
					color: #4260FA;
				}

				.icon-cc-me {
					color: #4260FA;
				}

			}
		}

		.narrow-todo-config-wrapper {
			height: 100%;
			display: block;
			padding: 20px 16px;
			background-color: #fff;
			border-radius: 6px;

			.item {
				width: 100%;
				height: 40px;
				margin: 0 0 4px;
				padding: 0 12px;
				position: relative;
				flex-direction: row;
				align-items: center;
				justify-content: flex-start;
				cursor: pointer;
				display: flex;

				i {
					width: 20px;
					height: 40px;
					font-size: 20px;
					line-height: 40px;
					margin-right: 12px;
					color: #5E6D82;
					position: relative;
				}

				.info {
					height: 100%;
					display: flex;
					align-items: center;

					.text {
						display: inline-block;
						margin: 0;
						line-height: 24px;
						height: 24px;
						font-size: 14px !important;
						font-weight: 500 !important;
					}

					.badge {
						width: 29px;
						height: 20px;
						background: #F04134;
						color: #fff;
						font-size: 12px;
						border-radius: 72px;
						line-height: 20px;
						text-align: center;
						position: absolute;
						right: 12px;
					}
				}

				&:hover {
					border-radius: 6px;
					background: #f4f6f9;
				}
			}
		}
	}
</style>
